import { Component, AfterContentInit, OnDestroy, HostBinding, HostListener, ViewChild, Input, Output, EventEmitter, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy, ViewContainerRef, TemplateRef, Renderer2 } from '@angular/core';
import { ButtonInfo, ButtonComponent } from '../button.component';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { EnvService } from 'src/app/env.service';
import { UUID } from 'angular2-uuid';
import { ButtonGroupService } from 'src/app/services/button-group.service';
import { clone } from 'lodash';

@Component({
  selector: 'app-button-proxy',
  templateUrl: './button-proxy.component.html',
  styleUrls: ['./button-proxy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonProxyComponent implements AfterContentInit, OnDestroy {
  @Input('button-class') buttonClass = '';
  @Input('group') group: string = '';
  @ViewChild('btn') button!: ButtonComponent;
  @ViewChild('caret') caret!: ElementRef;
  public dropdown!: HTMLElement;
  @ViewChild('contentRef') contentRef!: TemplateRef<any>;
  @Input('is-drop-down') isDropDown!: boolean;
  @Input('dropdown-width') dropDownWidth = 'calc(100vh - 0px)';
  @HostBinding('style.max-width') maxWidthStyle = 'auto';
  @HostBinding('attr.tabindex') tabIndex = '0';
  @HostListener('focusin', ['$event']) onFocusIn(event: FocusEvent) {
    // Only redirect focus when entering the proxy host. The active button and
    // caret are also inside this component and must remain independently focusable.
    if (event.target === this.domNode.nativeElement) {
      this.button?.Focus();
    }
  }
  @Output() click = new EventEmitter<ButtonInfo>();

  private _dropdownTitle: string = '';
  @Input('dropdown-title')
  set dropdownTitle(title) {
    this._dropdownTitle = title;
    this.cdr.markForCheck();
    this.cdr.detectChanges();
    if (this.buttonInfo) {
      this.RefreshView(this.buttonInfo);
    }
  }
  get dropdownTitle(): string {
    return this._dropdownTitle;
  }

  public dropDownLeft = '0px';
  private subscriptions = new SubScriptionMgr();
  private pressedKeys = new Set<string>();
  private removeDocumentKeydownListener: () => void;
  private removeDocumentKeyupListener: () => void;
  private removeWindowBlurListener: () => void;
  public buttonInfo!: ButtonInfo | undefined;
  public dataToggleString = 'dropdown'
  public destroyed = false;
  private resizeHandler!: AnyHandler;
  public dropDownVis = false;
  @Output() dropDownVisChange = new EventEmitter<boolean>();
  @HostBinding('attr.id') guiID: string;
  public dropdownGuiID = '';
  public dropdownTop = '0px';
  public dropdownLeft = '0px';
  public dropdownRight = '0px';
  public dropdownMaxHeight = '100vh';
  public setting = false;
  public caretTop: string = '0px';
  public caretCenter: string = '0px';
  public caretVis = false;

  public set(info: ButtonInfo) {
    this.setting = true;
    this.buttonInfo = undefined;
    this.cdr.detectChanges();
    this.buttonInfo = info;
    this.cdr.detectChanges();
    this.setting = false;
    this.button.dataTitle = !!info.title ? info.title : '';
    this.Resized();
  }
  public get guidId(): string | undefined {
    if (!this.buttonInfo) {
      return undefined;
    }
    return this.buttonInfo.guiId;
  }

  IsProxyControl(target: EventTarget | null): boolean {
    return target === this.domNode.nativeElement
      || target === this.button?.button?.nativeElement
      || target === this.button?.element?.querySelector('.sl-dropdown-toggle')
      || target === this.caret?.nativeElement;
  }

  IsToggleControl(target: EventTarget | null): boolean {
    return target === this.button?.element?.querySelector('.sl-dropdown-toggle');
  }

  FocusToggle() {
    const toggle = this.button?.element?.querySelector('.sl-dropdown-toggle') as HTMLElement;
    if (toggle) toggle.focus();
    else this.button?.Focus();
  }

  @Input('max-width')
  set maxWidth(size: string) {
    this.maxWidthStyle = size;
    this.cdr.detectChanges();
  }
  private changeDetector!: MutationObserver;
  constructor(private viewContainerRef: ViewContainerRef,
    private env: EnvService, private renderer: Renderer2,
    private cdr: ChangeDetectorRef, private domNode: ElementRef,
    private groups: ButtonGroupService) {
    this.removeDocumentKeydownListener = this.renderer.listen('document', 'keydown', (event: KeyboardEvent) => {
      this.pressedKeys.add(event.key.toLowerCase());
    });
    this.removeDocumentKeyupListener = this.renderer.listen('document', 'keyup', (event: KeyboardEvent) => {
      this.pressedKeys.delete(event.key.toLowerCase());
    });
    this.removeWindowBlurListener = this.renderer.listen('window', 'blur', () => this.pressedKeys.clear());
    this.guiID = UUID.UUID();
    this.dropdownGuiID = UUID.UUID();
  }

  ngAfterContentInit(): void {
    this.resizeHandler = () => {
      this.Resized();
    }
    window.addEventListener('resize', this.resizeHandler);

    if (!this.dropdown) {
      window.requestAnimationFrame(() => {
        this.ngAfterContentInit();
      });
      return;
    }
    this.Resized();
  }
  RefreshView(button: ButtonInfo) {
    if (this.buttonInfo && this.buttonInfo.guiId === button.guiId) {
      this.buttonInfo = button;
      if (!this.setting) {
        this.cdr.detectChanges();
      }
    }
  }
  Resized() {
    if (!this.dropdown) {
      const dropdown = document.getElementById(this.dropdownGuiID)
      if (!!dropdown) {
        this.dropdown = dropdown;
        this.cdr.detectChanges();

      } else {
        return;
      }
    }
    if (!this.button) {
      return;
    }
    const vis = this.dropDownVis;
    this.dropdownTop = '0px';
    this.dropdownLeft = '0px';
    this.cdr.detectChanges();

    const containerPosition = this.env.GetPosition(this.domNode.nativeElement);
    const containerRect = this.domNode.nativeElement.getBoundingClientRect();
    const topOffset = containerRect.y;

    this.dropdown.style.flexWrap = 'nowrap';
    const dropdownRect = this.dropdown.getBoundingClientRect();
    this.dropdown.style.setProperty('width', 'fit-content');
    this.cdr.detectChanges();

    const fullWidth = dropdownRect.width;
    let left = Math.max(0, containerPosition.left);
    left += containerRect.width / 2.0;
    left -= dropdownRect.width / 2.0;

    this.dropdownLeft = Math.max(0, left) + 'px';
    this.cdr.detectChanges();

    const maxWidth = Math.min(fullWidth, document.documentElement.clientWidth);
    left = Math.max(0, containerPosition.left);
    left += containerRect.width / 2.0;
    left -= maxWidth / 2.0;
    const right = left + fullWidth;
    const testWidth = right - left;

    if (right > document.documentElement.clientWidth) {
      left = document.documentElement.clientWidth - dropdownRect.width;
    }
    if (left < 0) {
      left = 0;
    }
    this.dropdownLeft = left + 'px';
    this.dropdownRight = 'auto';

    this.cdr.detectChanges();
    this.dropdownTop = `calc(${containerRect.bottom}px + .6rem)`;
    this.dropdown.style.setProperty('top', this.dropdownTop);
    this.cdr.detectChanges();

    this.dropdownMaxHeight = `calc(100vh - ${this.dropdownTop}`;
    this.cdr.detectChanges();

    this.dropdown.classList.toggle('hidden', !vis);
    this.caretVis = vis;
    this.dropdown.style.flexWrap = 'wrap';
    this.cdr.detectChanges();

    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    this.removeDocumentKeydownListener();
    this.removeDocumentKeyupListener();
    this.removeWindowBlurListener();
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = undefined as any;
    }
    this.destroyed = true;
  }
  ToggleDropDown(onOff?: boolean) {
    this.dropDownVis = !this.dropdown.classList.contains('hidden');
    if (this.dropDownVis === true) {
      this.caretVis = false;
      this.dropDownVis = false;
      this.dropDownVisChange.emit(this.dropDownVis);
      this.Resized();
      return;
    }
    this.groups.CloseAll();
    this.dropdown.classList.toggle('hidden', false);
    this.dropDownVis = (onOff !== undefined) ? onOff : !this.dropdown.classList.contains('hidden');
    this.cdr.detectChanges();
    this.dropDownVisChange.emit(this.dropDownVis);
    this.Resized();
  }
  DropdownReady() {
    if (document.getElementsByClassName('work-view').length === 0) {
      window.requestAnimationFrame(() => {
        this.DropdownReady();
      })
      return;
    }

    const dropdownViewRef = this.viewContainerRef.createEmbeddedView(this.contentRef);
    dropdownViewRef.detectChanges();

    for (const node of dropdownViewRef.rootNodes) {
      const workView = document.getElementsByClassName('work-view').item(0);
      if (workView) {
        const element: HTMLElement = workView.appendChild(node) as HTMLElement;
      }
    }
  }
  HandleButtonChange(info: ButtonInfo) {
    if (!this.buttonInfo) return;
    const hasChange = this.buttonInfo.isOn !== info.isOn;
    this.buttonInfo.isOn = info.isOn;
    if (this.buttonInfo.toggleable === true) {
      if (hasChange) {
        this.groups.Toggle(this.buttonInfo);
        this.RefreshView(info);
      }
    }
  }
  HandleClick() {
    if (this.buttonInfo) {
      this.click.emit(this.buttonInfo);
    }
  }
  Close() {
    this.dropDownVis = false;
    this.dropdown.classList.toggle('hidden', true);
    this.caretVis = false;
    this.cdr.detectChanges();
  }
  @HostListener('wheel', ['$event'])
  handleWheel(event: WheelEvent) {
    event.preventDefault();
  }
  @HostListener('keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight') && !this.HasNonArrowKeyDown()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  HasNonArrowKeyDown(): boolean {
    return Array.from(this.pressedKeys).some(key => !key.startsWith('arrow'));
  }
  HandleButtonKeyDown(event: KeyboardEvent) {
    if (event.key.startsWith('Arrow') && this.HasNonArrowKeyDown()) return;

    switch (event.key) {
      case 'ArrowDown':
        this.ToggleDropDown(true);
        event.preventDefault();
        event.stopPropagation();
      case 'ArrowUp':
      case 'Escape':
        this.ToggleDropDown(false);
        event.preventDefault();
        event.stopPropagation();
        break;
    }
  }
}
